import { render, staticRenderFns } from "./stage1.vue?vue&type=template&id=370361a7&scoped=true&"
import script from "./stage1.vue?vue&type=script&lang=js&"
export * from "./stage1.vue?vue&type=script&lang=js&"
import style0 from "./stage1.vue?vue&type=style&index=0&id=370361a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370361a7",
  null
  
)

export default component.exports